// extracted by mini-css-extract-plugin
export default {"double":"credit_double__bZ0Sp","doubleInput":"credit_doubleInput__kJCB0"};